import React from 'react';
import {
  AllLinksWrapper,
  LinkWrapper,
  PageLink,
  ContactInfo,
  AddressSeparator,
  LendiPhone,
  CompanyName,
  Separator,
  InnerWrapper,
} from './index.style';
import { GENERAL_PAGES } from '../../constants';
import { FooterAnalyticsContext } from '../utils/analytics';

export interface GeneralInfoProps {
  params?: string;
}

export const GeneralInfo: React.FC<GeneralInfoProps> = ({ params = '' }) => {
  const { analyticsForFooter } = React.useContext(FooterAnalyticsContext);

  return (
    <div>
      <AllLinksWrapper>
        <InnerWrapper>
          {GENERAL_PAGES.map((page, index) => (
            <LinkWrapper key={page.label}>
              <PageLink
                rel={page.label === 'Careers' ? 'noreferrer' : undefined}
                href={page.label === 'Careers' ? page.url : `${page.url}${params}`}
                target={page.label === 'Careers' ? '_blank' : undefined}
                onClick={() => analyticsForFooter(page.label)}
              >
                {page.label}
              </PageLink>
              {index !== 5 && <Separator />}
            </LinkWrapper>
          ))}
        </InnerWrapper>
      </AllLinksWrapper>
      <ContactInfo>
        <CompanyName>Lendi Pty Ltd</CompanyName>
        <AddressSeparator> · </AddressSeparator>
        <div>Bay 14 (Locomotive Workshop), 2 Locomotive St, Eveleigh NSW 2015</div>
        <AddressSeparator> · </AddressSeparator>
        <LendiPhone href="tel:1300323181" onClick={() => analyticsForFooter('1300 323 181')}>
          Ph: 1300 323 181
        </LendiPhone>
      </ContactInfo>
    </div>
  );
};
